import Src20 from "@/assets/images/svg-icons/main-categories-icons/20.svg";
import Src21 from "@/assets/images/svg-icons/main-categories-icons/21.svg";
import Src22 from "@/assets/images/svg-icons/main-categories-icons/22.svg";
import Src23 from "@/assets/images/svg-icons/main-categories-icons/23.svg";
import Src24 from "@/assets/images/svg-icons/main-categories-icons/24.svg";
import Src25 from "@/assets/images/svg-icons/main-categories-icons/25.svg";
import Src26 from "@/assets/images/svg-icons/main-categories-icons/26.svg";
import Src28 from "@/assets/images/svg-icons/main-categories-icons/28.svg";
import Src29 from "@/assets/images/svg-icons/main-categories-icons/29.svg";
import { borderWidth, colors, shadows, sizes, spacings } from "@/assets/themes";
import { CardBase } from "@/components/Styles/Base";
import polyglot from "@/utils/polyglot";
import { useQueryClient } from "@tanstack/react-query";
import { useFormikContext } from "formik";
import { Block, Body16, List, Radio } from "../../components";
import {
  getIsCategoryCustomById,
  getMainParentCategoryById,
} from "../categoriesNavigationModal/utils";
import { StyledFormControl } from "../categoryForms/common/fields";
import StepTitle from "../categoryForms/common/StepTitle";

const IMAGES = {
  20: Src20,
  21: Src21,
  22: Src22,
  23: Src23,
  24: Src24,
  25: Src25,
  26: Src26,
  28: Src28,
  29: Src29,
};

const ServiceTypeSelection = ({ title }) => {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData(["recurring_jobs_form_data"]);
  const { setFieldValue, values } = useFormikContext();

  const getCategoryName = (id) =>
    data.categories.find(({ category_id }) => category_id === id).category_name;

  const handleSelectService = (id) => {
    setFieldValue("category", id);
    setFieldValue("title", getCategoryName(id));
    setFieldValue("price_per_hour", "");
    setFieldValue("start_hour", "");
    setFieldValue("end_hour", "");
    setFieldValue("nb_hours", "");
  };

  return (
    <>
      <StepTitle>{title}</StepTitle>
      <StyledFormControl>
        <CardBase
          border
          flat
          css={`
            padding-top: ${spacings.xs};
            padding-bottom: ${spacings.xs};
            overflow: hidden;
          `}
        >
          <List.Group>
            {(data?.categories || []).map(({ category_id }) => (
              <List.Item
                key={category_id}
                withGutters
                onClick={() => handleSelectService(category_id)}
                LeftComponent={() => (
                  <Block
                    borderRadius={{ xs: spacings.sm, md: spacings.m }}
                    padding={{
                      xs: `calc(${spacings.xs} + 2px)`,
                      md: spacings.s,
                    }}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    boxShadow={shadows.xs}
                    border={`${borderWidth.s} solid ${colors.border}`}
                    width={{ xs: sizes.size32, md: sizes.size48 }}
                    height={{ xs: sizes.size32, md: sizes.size48 }}
                  >
                    <img
                      css={`
                        filter: grayscale(100%) brightness(0.5);
                        width: 100%;
                        height: auto;
                      `}
                      src={IMAGES[getMainParentCategoryById(category_id).id]}
                      alt={polyglot.t(`categories.${category_id}.name`)}
                    />
                  </Block>
                )}
                RightComponent={() => (
                  <Radio checked={values.category === category_id} />
                )}
              >
                <Body16>{getCategoryName(category_id)}</Body16>
              </List.Item>
            ))}
          </List.Group>
        </CardBase>
      </StyledFormControl>
    </>
  );
};

export default ServiceTypeSelection;
